<template>
  <div class="container">
    <van-swipe :autoplay="3000" v-if="simages.length > 0" class="swiper">
      <van-swipe-item v-for="(image, index) in simages">
        <!-- <img v-lazy="image.img_urls" width="100%" height="230px" fit="contain"/> -->
        <van-image :src="image.img_urls" width="100%" height="230px">
          <template v-slot:loading>
            <van-loading type="spinner" size="30" />
          </template>
        </van-image>
      </van-swipe-item>
    </van-swipe>
    <div class="panel panel-default">
      <div class="panel-heading">
        <div class="category">
          <a class="category-top">简介</a>
          <a class="category-bottom">Brief introduction</a>
        </div>
      </div>
      <div class="panel-body" style="padding-top: 0px" v-html="summary"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  props: {
    simages: {
      type: Array,
      require: true,
    },
    summary: {
      type: String,
      default: "",
    },
  },
  watch: {},
  methods: {},
  created() {},
};
</script>
<style>
.van-image{
	width: 100%;
	height: 100%;
	display: block;
}
.van-swipe {
  border-radius: 10px;
  overflow: hidden;
}
.swiper {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.35);
  margin-bottom: 18px;
}
.category {
  position: relative;
}
.category::after {
  width: 90%;
  content: "";
  position: absolute;
  bottom: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.van-swipe__indicator {
  background-color: rgba(255, 255, 255, 0.726);
  opacity: 0.7;
}
.van-swipe__indicator--active {
  background-color: #fff;
  width: 16px;
  border-radius: 12px;
  opacity: 1;
}

</style>